import { ApolloQueryResult } from '@apollo/client';
import { IncomingMessage } from 'http';
import { createSSRApolloClient, handleQuery } from '@99designs/graph-utils';
import { GetDailyExchangeRateDocument } from '../graphql/DailyExchangeRate.generated';
import type { CurrencyCode } from '@99designs/i18n';
import type { GetDailyExchangeRateQuery } from '../graphql/DailyExchangeRate.generated';

export async function getExchangeRate(
    req: IncomingMessage,
    currency: CurrencyCode
): Promise<number> {
    const { data } = await fetchExchangeRate(req, currency);
    const defaultRate = 0;

    if (!data) {
        return defaultRate;
    }

    return data?.dailyExchangeRate || defaultRate;
}

function fetchExchangeRate(
    req: IncomingMessage,
    currency: CurrencyCode
): Promise<ApolloQueryResult<GetDailyExchangeRateQuery>> {
    return handleQuery<GetDailyExchangeRateQuery>(
        createSSRApolloClient(req),
        {
            query: GetDailyExchangeRateDocument,
            variables: {
                currency,
            },
        },
        'Exchange rate error received'
    );
}
